<div class="st-page">
  <div class="st-page-head">
    <div class="fsh-head-left">
      <button type="button" class="sfr-icon-btn" (click)="goBack()"><i class="ri-arrow-left-line"></i></button>
      <div>
        <h1 class="st-title">{{ className }}</h1>
        <p class="st-subtitle">{{ studentName }}</p>
      </div>
    </div>
  </div>

  <div class="st-tabs">
    <div class="st-tab" [class.active]="activeTab === 'unpaid'" (click)="setTab('unpaid')">{{ 'unpaid' | translate }}</div>
    <div class="st-tab" [class.active]="activeTab === 'history'" (click)="setTab('history')">{{ 'paymentHistory' | translate }}</div>
  </div>

  <!-- ---------- Unpaid tab ---------- -->
  <ng-container *ngIf="activeTab === 'unpaid'">
    <div class="fsh-stat-card st-card">
      <ng-container *ngIf="!fetchingStudentData; else statSkeleton">
        <div class="fsh-stat-row">
          <div>
            <div class="fsh-stat-label">{{ 'totalAmount' | translate }}</div>
            <div class="fsh-stat-value">{{ formatAmount(totalAmount) }}</div>
          </div>
          <div>
            <div class="fsh-stat-label">{{ 'unpaid' | translate }}</div>
            <div class="fsh-stat-value">{{ formatAmount(pendingAmount) }}</div>
          </div>
        </div>
        <div class="fsh-progress-track">
          <div class="fsh-progress-fill" [style.width.%]="feesPercentagePending"></div>
        </div>
      </ng-container>
      <ng-template #statSkeleton>
        <div class="fsh-stat-skeleton"></div>
      </ng-template>
    </div>

    <div class="st-tv-list" *ngIf="fetchingStudentData">
      <div class="st-card fsh-skeleton-card" *ngFor="let s of [1,2,3,4]"></div>
    </div>

    <ng-container *ngIf="!fetchingStudentData">
      <div class="fsh-fee-list" *ngIf="pendingFeeInfo.length">
        <div class="st-card fsh-fee-card" *ngFor="let f of pendingFeeInfo">
          <div class="fsh-fee-head">
            <div class="fsh-fee-name">{{ f.TermName || f.typename }}</div>
            <span class="fsh-status-tag" [style.background]="f.colorCode">{{ f.feeStatus }}</span>
          </div>
          <div class="fsh-fee-due">{{ 'due' | translate }} {{ formatDate(f.DueDate) }}</div>
          <div class="fsh-fee-breakdown">
            <div class="fsh-fee-line" *ngFor="let d of f.studentFeeDetail">
              <span>{{ d.label }}</span><span>{{ formatAmount(d.value) }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="st-empty-state" *ngIf="!pendingFeeInfo.length">
        <i class="ri-file-list-3-line"></i> {{ 'noFeesData' | translate }}
      </div>
    </ng-container>
  </ng-container>

  <!-- ---------- Payment History tab ---------- -->
  <ng-container *ngIf="activeTab === 'history' && !fetchingStudentData">
    <div class="fsh-stat-card st-card">
      <div class="fsh-stat-row">
        <div>
          <div class="fsh-stat-label">{{ 'totalAmount' | translate }}</div>
          <div class="fsh-stat-value">{{ formatAmount(totalAmount) }}</div>
        </div>
        <div>
          <div class="fsh-stat-label">{{ 'totalPaid' | translate }}</div>
          <div class="fsh-stat-value">{{ formatAmount(paidAmount) }}</div>
        </div>
      </div>
      <div class="fsh-progress-track">
        <div class="fsh-progress-fill fsh-progress-fill-paid" [style.width.%]="feesPercentagePaid"></div>
      </div>
    </div>

    <div class="fsh-fee-list" *ngIf="paidFeeInfo.length">
      <div class="st-card fsh-fee-card" *ngFor="let f of paidFeeInfo">
        <div class="fsh-fee-head">
          <div class="fsh-fee-name">{{ f.TermName || f.typename }}</div>
          <span class="fsh-status-tag" [style.background]="f.colorCode">{{ f.feeStatus }}</span>
        </div>
        <div class="fsh-fee-due">{{ 'paidOn' | translate }} {{ formatDate(f.PaymentDate) }}</div>
        <div class="fsh-fee-breakdown">
          <div class="fsh-fee-line" *ngFor="let d of f.studentFeeDetail">
            <span>{{ d.label }}</span><span>{{ formatAmount(d.value) }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="st-empty-state" *ngIf="!paidFeeInfo.length">
      <i class="ri-file-list-3-line"></i> {{ 'noFeesData' | translate }}
    </div>
  </ng-container>
</div>
